import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { LogInUiConfigService } from '../../../../core/services/logInUiConfig.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-update-login-ui-configurator',
  templateUrl: './update-login-ui-configurator.component.html',
  styleUrls: ['./update-login-ui-configurator.component.scss']
})
export class UpdateLoginUiConfiguratorComponent implements OnInit {

  constructor(
    private dialog: MatDialogRef<UpdateLoginUiConfiguratorComponent>,
    private snackBar: MatSnackBar,
    private authenticationService: AuthenticationService,
    private loginUiConfig: LogInUiConfigService
  ) { }

  note = this.loginUiConfig.logInUiConfigVariables.note;
  title = this.loginUiConfig.logInUiConfigVariables.title;
  logoAndTitle = this.loginUiConfig.logInUiConfigVariables.logoAndTitle;
  configureLogInPage = this.loginUiConfig.logInUiConfigVariables.configureLogInPage;
  newData = {
    note: this.note,
    configureLogInPage: this.configureLogInPage,
    title: this.title,
    logoAndTitle: this.logoAndTitle
  }
  logInUiDetails: UntypedFormGroup;
  data: any;

  ngOnInit(): void {
    this.logInUiDetails = new UntypedFormGroup({
      configureLogInPage: new UntypedFormControl(this.configureLogInPage.toString()),
      title: new UntypedFormControl(this.title),
      logoAndTitle: new UntypedFormControl(this.logoAndTitle),
    })
  }

  onClose() {
    this.dialog.close(false);
  }

  updateLogInUiConfigurationValue(form) {
    let newData = {
      note: this.note,
      configureLogInPage: JSON.parse(form.value?.configureLogInPage),
      title: form.value?.title,
      logoAndTitle: form.value?.logoAndTitle
    }

    this.authenticationService.setLogInUiConfiguration(newData)
      .subscribe({
        next: (data: any) => {
          this.dialog.close(true);
          this.snackBar.open(data.actionMessage, "Ok", { duration: 3000 });
        },
        error: (err) => {
          this.dialog.close(true);
          this.snackBar.open(err.error?.actionMessage, "Ok", { duration: 3000 });
        }
      })
  }
}
